module.exports = __webpack_public_path__ + "img/logo-with-title.a36fe96.svg";